// extracted by mini-css-extract-plugin
export default {"container":"checkbox_container__ev5pa","icon":"checkbox_icon__QqhQf","isBlack":"checkbox_isBlack__2HD2j","disabled":"checkbox_disabled__2fWSP"};